// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"OrderDetailsGrid_gridContainer__1xUeb","gridOverlay":"OrderDetailsGrid_gridOverlay__inA_Y"};